<template>
    <el-page-header @back="goBack" :content="content" :title="title"/>
</template>

<script>
export default {
    name: "GoBack",
    props: {
        title: String,
        content: String,
        beforeBack: Function // 拦截返回之前
    },
    methods: {
        goBack() {
            const fn = () => { this.$router.go(-1) }
            if (typeof this.beforeBack === "function") {
                this.beforeBack(fn)
            } else {
                fn()
            }
        }
    }
}
</script>

<style scoped>

</style>
